import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { StorageService } from "../../services/storage.service";

@Component({
  selector: "app-pro-dashboard",
  templateUrl: "./pro-dashboard.component.html",
  styleUrls: ["./pro-dashboard.component.css"],
})
export class ProDashboardComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  page: number = 1;
  page_size: number = 10;
  videoList: any;
  video: any;
  prolength: any;
  department: Object;
  dept: any;
  classroom: Object;
  class: any;
  subject: Object;
  subjectData: any;
  department_id: any;
  subject_id: any;
  classroom_id: any;

  filter_from: any;
  filter_end: any;
  timeid: any;
  timetable_id: number;
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public router: Router,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private datepipe: DatePipe,
    private route: ActivatedRoute
  ) {}
  roleId = this.storageService.getRole();
  ngOnInit() {
    this.getvideoList();
    this.getDepartment();
    this.getSubject();
    this.getclassroom();
  }
  async getvideoList() {
    this.spinner.show();
    this.timeid = this.route.params.subscribe((params) => {
      this.timetable_id = +params["id"];
    });
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      page: this.page,
      page_size: this.page_size,
      timetable_id: this.timetable_id,
      department_id: this.department_id,
      subject_id: this.subject_id,
      classroom_id: this.classroom_id,
      camera_start: this.filter_from,
      camera_end: this.filter_end,
    };
    this.videoList = await this.globalService.get(
      "classVideoDetail/get-video-details",
      filter
    );
    this.video = this.videoList["content"]["rows"];
    this.prolength = this.video.length;
    this.spinner.hide();
  }
  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: "5",
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,true
    );

    this.dept = this.department["content"];
    this.spinner.hide();
  }
  getFilterDate(filter_date) {
    if (filter_date) {
      let from = moment(filter_date[0]).format("YYYY-MM-DD 00:00:00");
      let end = moment(filter_date[1]).format("YYYY-MM-DD 23:59:59");

      this.filter_from = this.datepipe.transform(
        from,
        "yyyy-MM-dd HH:mm:ss",
        "+0530"
      );
      this.filter_end = this.datepipe.transform(
        end,
        "yyyy-MM-dd HH:mm:ss",
        "+0530"
      );
    }
  }
  async getclassroom() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",
      filter,true
    );

    this.class = this.classroom["content"];
    this.spinner.hide();
  }
  async getSubject() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,true
    );

    this.subjectData = this.subject["content"];
    this.spinner.hide();
  }

  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }
  Filter(department_id, subject_id, classroom_id) {
    this.department_id = department_id;
    this.subject_id = subject_id;
    this.classroom_id = classroom_id;
    this.page = 1;
    this.getvideoList();
  }

  res() {
    this.department_id = null;
    this.subject_id = null;
    this.classroom_id = null;
    this.filter_from = null;
    this.filter_end = null;

    this.getvideoList();
  }

  back() {
    this.router.navigateByUrl("/timetable");
  }
}
